import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Main from 'layouts/Main';
import Container from 'components/Container';

const TermsAndConditions = () => {
  const theme = useTheme();
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    fetch('/terms-and-conditions.html')
      .then(response => response.text())
      .then(data => setHtmlContent(data))
      .catch(error => console.error('Error loading terms:', error));
  }, []);

  return (
    <Main>
      <Container>
        <Box boxShadow={4} borderRadius={2}>
          <Box bgcolor={theme.palette.primary.main} borderRadius={2}>
            <Container paddingX={{ xs: 2, sm: 4 }}>
              <Typography
                variant={'h4'}
                gutterBottom
                sx={{
                  fontWeight: 700,
                  color: theme.palette.common.white,
                }}
              >
                Terms and Conditions
              </Typography>
              <Typography
                gutterBottom
                sx={{
                  color: theme.palette.common.white,
                }}
              >
                Last updated <strong>January 01, 2025</strong>
              </Typography>
            </Container>
            <Box
              component={'svg'}
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 1920 100.1"
              width={1}
              marginBottom={-1}
            >
              <path
                fill={theme.palette.background.paper}
                d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
              ></path>
            </Box>
          </Box>
          <Container
            paddingTop={'0 !important'}
            paddingX={{ xs: 2, sm: 4 }}
            position={'relative'}
            top={0}
          >
            <Box
              sx={{
                '& [data-custom-class="body"], & [data-custom-class="body"] *': {
                  background: 'transparent !important',
                },
                '& [data-custom-class="title"], & [data-custom-class="title"] *': {
                  fontFamily: 'Arial !important',
                  fontSize: '26px !important',
                  color: '#000000 !important',
                },
                '& [data-custom-class="subtitle"], & [data-custom-class="subtitle"] *': {
                  fontFamily: 'Arial !important',
                  color: '#595959 !important',
                  fontSize: '14px !important',
                },
                '& [data-custom-class="heading_1"], & [data-custom-class="heading_1"] *': {
                  fontFamily: 'Arial !important',
                  fontSize: '19px !important',
                  color: '#000000 !important',
                },
                '& [data-custom-class="heading_2"], & [data-custom-class="heading_2"] *': {
                  fontFamily: 'Arial !important',
                  fontSize: '17px !important',
                  color: '#000000 !important',
                },
                '& [data-custom-class="body_text"], & [data-custom-class="body_text"] *': {
                  color: '#595959 !important',
                  fontSize: '14px !important',
                  fontFamily: 'Arial !important',
                },
                '& [data-custom-class="link"], & [data-custom-class="link"] *': {
                  color: '#3030F1 !important',
                  fontSize: '14px !important',
                  fontFamily: 'Arial !important',
                  wordBreak: 'break-word !important',
                },
                '& ul': {
                  listStyleType: 'square',
                },
                '& ul > li > ul': {
                  listStyleType: 'circle',
                },
                '& ul > li > ul > li > ul': {
                  listStyleType: 'square',
                },
                '& ol li': {
                  fontFamily: 'Arial',
                },
              }}
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </Container>
        </Box>
      </Container>
    </Main>
  );
};

export default TermsAndConditions;
